import { IDomainType } from ".";
import * as React from "react";

import { DesignToken, Heading, Icon, IconSource, Text, Tooltip } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { Wrapper } from "./styles";

interface ISetupDomainFirstStepItemProp {
  topText: string;
  bottomText: string;
  iconSource: IconSource;
  disabled: boolean;
  value: IDomainType;
  handleSetDomainType: (type: IDomainType) => void;
}

export const SetupDomainFirstStepItem: React.FC<ISetupDomainFirstStepItemProp> = ({
  topText,
  bottomText,
  handleSetDomainType,
  iconSource,
  value,
  disabled,
}) => {
  const handleClick = (): void => {
    if (disabled) {
      return;
    }

    handleSetDomainType(value);
  };

  return (
    <Wrapper disabled={disabled} onClick={handleClick} id={disabled ? "" : value}>
      <Tooltip
        isVisible={disabled ? undefined : false}
        kind="invert"
        placement="top"
        triggerRenderer={
          <Icon
            source={iconSource}
            size="xxxlarge"
            customColor={withVar(disabled ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicPrimary)}
          />
        }
      >
        Already added
      </Tooltip>
      <Heading
        size="sm"
        customColor={withVar(disabled ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicPrimary)}
      >
        {topText}
      </Heading>
      <Text customColor={withVar(disabled ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicSecondary)}>
        {bottomText}
      </Text>
    </Wrapper>
  );
};
